<template>
  <div style="height: 100%; width: 100%">
    <v-layout v-if="!loaded">
      <v-progress-circular
        style="margin: auto; padding-top: 45%"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-layout>
    <v-layout row style="height: 100%; width: 100%" v-if="loaded">
      <v-flex xs7 style="height: height:100vh; width: 100%;">
        <oil-map style="height: 100vh; width: 100%" />
      </v-flex>
      <v-flex xs5 style="height: 100%; width: 100%">
        <oil-tab style="height: 100%; width: 100%" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const oilNamespace = createNamespacedHelpers("oil");

import dataSources from "@/store/modules/data-sources";
import charts from "@/store/modules/charts";
import oil from "@/store/modules/oil";

const OilMap = () => import("@/components/charts/oil/map.vue");
const OilTab = () => import("@/components/charts/oil/tabs.vue");
export default {
  data() {
    return {
      loaded: false,
    };
  },
  components: {
    "oil-map": OilMap,
    "oil-tab": OilTab,
  },
  methods: {
    ...oilNamespace.mapActions(["aLoadLocations"]),
    async loadData() {
      await this.aLoadLocations();
      this.loaded = true;
    },
  },
  beforeMount() {},
  beforeCreate: function () {
    // this.$store.registerModule('dataSources', dataSources);
    if (typeof this.$store.state["dataSources"] == "undefined") {
      this.$store.registerModule("dataSources", dataSources);
    }
    if (typeof this.$store.state["charts"] == "undefined") {
      this.$store.registerModule("charts", charts);
    }
    if (typeof this.$store.state["oil"] == "undefined") {
      this.$store.registerModule("oil", oil);
    }
    // this.$store.registerModule('charts', charts);
  },
  mounted() {
    this.loadData();
  },
};
</script>
